import { ArcRotateCamera, Vector3 } from '@babylonjs/core';
import { Game } from './Game';
import { GameState } from './GameState';

export class Intro {
  private videoContainer: HTMLDivElement | null = null;
  private videoElement: HTMLVideoElement | null = null;

  constructor(public game: Game) {}

  async create() {
    this.game.scene.activeCamera = new ArcRotateCamera('default_camera', -Math.PI / 2, Math.PI / 2, 10, Vector3.Zero());

    this.playIntroVideo();
  }

  private playIntroVideo() {
    // Create fullscreen container
    this.videoContainer = document.createElement('div');
    this.videoContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `;

    // Create video element
    this.videoElement = document.createElement('video');
    this.videoElement.src = 'assets/video/intro.mp4';
    this.videoElement.style.cssText = `
      width: 100%;
      height: 100%;
      object-fit: cover;
    `;
    this.videoElement.autoplay = true;
    this.videoElement.playsInline = true;

    // Handle video end - go to main menu
    this.videoElement.addEventListener('ended', () => {
      this.skipIntro();
    });

    // Click to skip
    this.videoContainer.addEventListener('click', () => {
      this.skipIntro();
    });

    // Keyboard to skip (Enter, Space, Escape)
    const keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
        document.removeEventListener('keydown', keyHandler);
        this.skipIntro();
      }
    };
    document.addEventListener('keydown', keyHandler);

    this.videoContainer.appendChild(this.videoElement);
    document.body.appendChild(this.videoContainer);

    // Start playback
    this.videoElement.play().catch(() => {
      // If autoplay fails (browser policy), skip to main menu
      this.skipIntro();
    });
  }

  private skipIntro() {
    if (!this.game.user.intro) {
      this.game.user.intro = true;
      this.game.user.save();
    }

    if (this.videoElement) {
      this.videoElement.pause();
      this.videoElement.src = '';
      this.videoElement = null;
    }
    if (this.videoContainer) {
      this.videoContainer.remove();
      this.videoContainer = null;
    }
    this.mainMenu();
  }

  mainMenu() {
    this.game.routeTo(GameState.MAIN);
  }
}
